module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAANCAYAAACZ3F9/AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEASURBVHgBfZBNzgFBEIarvnKAL+Nntr0gYUHGDcZN3ECcADs7sXQMJ8ARjMQkTLAcIYyNED+tZ8bv6Fabrq7qp6rfF0FEOpdvIeBialtt+BGZXKECyI3TnqrIsgaL4XUedBDqzthqyKB0tlDz+35+AWLkrV1PS+hiIZiiZmopHTar5UAFibMxs4dd8vPNetlXwVFI/CjI6TFVBmtx3ZRB4fVbS11Uax/FCCQFQzjfA0QzvPG+Y49K0Tck2Sg0YfltNpMZRt/QSxNwGKjcJhXka/rlNqmgx0AVjMww/mPH61YGRWQ83cbzX5E81z3cJ3Yd22qCIoLNSX2HnLvTidW5Abs9hAUeQ6uuAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Vector.png
// module id = f1dQ
// module chunks = 1